// @flow

// NOTE: en caso de dudas, flow puede inferir el tipo de una función con:
// flow type-at-pos SomeFile.js LineNum ColumnNum

// NOTE: Para instalar flow en VSCODE:
// sudo npm install --global flow-bin
// sudo yarn global add flow-typed
// instalar extensión de VSCODE: Flow Language Support
// Si hay conflictos con TypeScript, poner estas propiedades en las preferencias:
// "flow.useNPMPackagedFlow": true,
// "javascript.validate.enable": false,

import * as React from 'react';
import { Component } from 'react';
import localforage from 'localforage';
import mapSeries from 'async/mapSeries';
import {Icon} from 'react-fa';
import _ from 'lodash';
import $ from 'jquery';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Alert from 'react-s-alert';

import Tree from './Tree.jsx';
import MapUI from './MapUI.jsx';
import Shp from './Shp.js';
import SideBar from './SideBar.jsx';
import theme from './theme.js';
import Role from './roles.js';
import AppBar from './AppBar.jsx';
import Toolbar from './Toolbar.jsx';
import Medidas from './Medidas.jsx';
import FourMaps from './FourMaps.jsx';
import Launcher from './Launcher.jsx';
import TreeItemDir from './TreeItemDir.jsx';
import TreeItemPng from './TreeItemPng.jsx';
import TreeItemShp from './TreeItemShp.jsx';
import TreeItemObs from './TreeItemObs.jsx';
import TreeItemSen from './TreeItemSen.jsx';
import EscalaLyr from './EscalaLyr.jsx';
import DialogThematic from './DialogThematic.jsx';
import DialogTools from './DialogTools.jsx';
import DialogMav from './DialogMav.jsx';
import DialogNota from './DialogNota.jsx';
import DialogSensor from './DialogSensor.jsx';
import DialogReport from './DialogReport.jsx';
import MenuBook from './MenuBook.jsx';
import Help from './Help.jsx';
import TreeItemMenu from './TreeItemMenu.jsx';
import DialogUser from './DialogUser.jsx';
import SelectUser from './SelectUser.jsx';
import Wait from './Wait.jsx';
import ClimaCooprinsem from './ClimaCooprinsem.jsx';
import Diff from './Diff.jsx';
import CollectPoints from './CollectPoints.jsx';
import ShowCollectPoint from './ShowCollectPoint.jsx';
import TreeItemCollect from './TreeItemCollect.jsx';
import XDialog from './XDialog.jsx';
import PopUp from './PopUp.jsx';
import Aviso from './Aviso.jsx';
import CentralFert from './CentralFert.jsx';
import CollectMkdir from './CollectMkdir.jsx';

import {NO_MEASURE} from './types.js';
import {
  takeDir, takeFilename, takeExtension, path_is_inside_bi, path_is_inside, isNumber, noop,
  get_filelist, hs_bool, is_date, strip_end_slash, fixslash, fnot, mk_title, f_and3
} from './utils.js';
import {preload_escalas} from './make_book_util.js';
import {fetch_users_min, does_path_exists} from './fetch_things.js';
import {T_DIR, T_MS} from './codtype.js';
import {ROOT_DIR, USE_PIXEL_TOOL, SHOW_MS, ms_icons, PATH_ESCALA_MT, EMPTY_USER} from './consts.js';
import {get_path_escala} from './Escala.jsx';
import {remote_save, save_my_account} from './save_my_account.js';

import type {
  T_Node, T_Next, T_NextErrOk, T_User, T_Item, T_ResultMeasure, T_Obs, T_Sen, T_ErrOk, T_IconPair, T_CollectFolder,
  T_Paths, T_NextPath, T_Date, T_NextDate, T_MapnikMethods, T_ReportEntry, T_UserMin, T_UsersMinErr, T_Png_Culti,
  T_CollectPoint
} from './types.js';
import type {T_Kind} from './codtype.js';
import type {T_CloseOpts} from './TreeItemShp.jsx';

import './css/App.css';
import './css/TreeItem.css';


window.$ = $;

const S = require('underscore.string'),
      alertify = require('alertifyjs');


alertify.defaults.glossary.ok = 'Ok';
alertify.defaults.glossary.cancel = 'Cancelar';



type T_AppProps = {
  user    : T_User,
  domain  : string,
  launcher: Launcher,
  height  : number,
  width   : number,
};



type T_Trans = {
  cx    : number,
  cy    : number,
  width : number,
  height: number,
  msg   : React.Node,
  cod   : string
};



export type T_ItemMenu = {
  px  : number,
  py  : number,
  node: T_Item
}



type T_AppState = {
  user                   : T_User,
  show_tree              : boolean,
  four_maps              : boolean,
  symmetric_four_maps    : boolean,  // si symmetric_four_maps es false y four_maps es true, app.ready activará show_dialog_thematic
  review_thematic        : boolean,  // a menos que review_thematic sea true (eso indica que queremos revisar un MT existente)
  fix_zoom               : boolean,
  filelist               : Array<T_Item>,
  show_menu_user         : boolean,
  show_dialog_user_create: boolean,
  show_dialog_user_edit  : boolean,
  show_dialog_thematic   : boolean,
  show_dialog_tools      : boolean,
  window_drag            : boolean,
  png_opacity            : number,
  simplify_keep          : number,
  num_decimals           : number,
  ms_icon_pair           : T_IconPair,
  edit_users             : Array<T_UserMin>,
  num_colors_escala      : number,
  name_escala            : string,
  inv_escala             : boolean,
  result_measure         : T_ResultMeasure,
  showing_mav            : boolean,          // este es un simple reflejo de toolbar.state.show_mav
  closing_four_maps      : boolean,
  obs                    : ?T_Obs,
  sen                    : ?T_Sen,
  show_escalas_below     : boolean,
  alpha                  : ?T_Trans,
  include_mav_book       : boolean,         // incluir mavs en el informe de servicios?
  include_mt_book        : boolean,         // incluir mts en el informe de servicios?
  show_config_book       : boolean,
  mapnik_method          : T_MapnikMethods,
  show_help              : boolean,
  tree_item_menu         : ?T_ItemMenu,
  report_entries         : {entries: Array<T_ReportEntry>, path: string},
  disable_sidebar        : boolean,
  wait                   : boolean,
  open_last              : boolean,
  change_culti_on_close  : boolean,
  building_doc           : boolean,
  ui_clima_cooprinsem    : boolean,
  bios                   : Array<T_Png_Culti>,
  collect_folder         : ?T_CollectFolder,
  collect_point_opened   : ?T_CollectPoint,
  show_jpg_url           : string,
  show_jpg_title         : string,
  show_jpg_w             : number,
  show_jpg_h             : number,
  cond_show_collect_point: boolean,
  cond_show_jpg          : boolean,
  show_appbar            : boolean,
  show_popup             : boolean,
  show_aviso             : boolean,
  show_central_fert      : boolean,
  show_collect_mkdir     : bollean,
  collect_mkdir_path     : string,
  custom_warning         : ?React.Node
};



export type T_Conv = {
  id        : number,
  ismf      : boolean,
  name      : string,
  conversion: string
};



export type T_Ready = {
  [string]: boolean;
};


export type T_FirstCultiResponse = {
  in_dir  : string,
  response: string
};



export function get_state_collect(collect: ?T_CollectFolder) {
  const is_opening = (collect != null);

  return {
    collect_folder         : collect,
    collect_point_opened   : null,
    show_jpg_url           : '',
    show_tree              : ! is_opening,
    disable_sidebar        :   is_opening,
    show_appbar            : ! is_opening,
    cond_show_collect_point: true,
    cond_show_jpg          : true
  };
}




export default class App extends Component<T_AppProps, T_AppState> {
  remote          : string;
  is_ready        : T_Ready;
  convs           : Array<T_Conv>;    // todas las conversiones de muestras
  mf_convs        : Array<T_Conv>;    // conversiones de muestras foliares
  normal_convs    : Array<T_Conv>;    // conversiones de muestras de suelo
  agrosat_user    : boolean;
  allow_testing   : boolean;
  dev_mode        : boolean;
  use_color_brewer: boolean;
  sidebar         : SideBar;
  map_ui          : MapUI;
  tree            : ?Tree;
  four_maps       : ?FourMaps;
  dialog_tools    : ?DialogTools;
  dialog_thematic : ?DialogThematic;
  dialog_nota     : ?DialogNota;
  dialog_sensor   : ?DialogSensor;
  medidas         : ?Medidas;
  dialog_mav      : ?DialogMav;
  dialog_report   : ?DialogReport;
  bar             : AppBar;
  toolbar         : ?Toolbar;
  tree_item_menu  : ?TreeItemMenu;
  escala_lyr      : ?EscalaLyr;
  select_user     : ?SelectUser;
  dialog_user_me  : ?DialogUser;     // si estoy editando mi cuenta dialog_user_me es ese diálogo.
  dialog_user_make: ?DialogUser;     // si estoy creando un usuario dialog_user_make es ese diálogo.
  dlg_cooprinsem  : ?ClimaCooprinsem;
  show_ms         : boolean;
  show_ms_book    : boolean;
  tree_opened     : boolean;     // se hizo el setup inicial del árbol?
  diff            : ?Diff;
  item_collect    : ?TreeItemCollect;
  collect         : ?CollectPoints;
  central_fert    : ?CentralFert;
  
  close_menus      : () => void;
  close_dialog_user: () => void;
  map_clicked      : (i: number) => void;
  toggle_four_maps : (symmetric: boolean, next?: T_Next) => void;
  toggle_fix_zoom  : () => void;
  dev_mode_testing : () => void;
  config_book      : () => void;
  start_book       : (font_size: number, method: T_MapnikMethods, date1: string, date2: string) => void;
  create_user      : (user: ?T_User) => void;
  save_my_account  : (user: ?T_User) => void;
  is_black         : (path: string) => boolean;
  close_alpha      : () => void;
  


  constructor(props: T_AppProps) {
    super(props);

    this.remote           = `https://${props.domain}`;
    this.is_ready         = {};
    this.convs            = [];
    this.agrosat_user     = Role.is_agrosat_user(props.user.role) && props.user.role !== Role.coordinador_externo;
    this.dev_mode         = props.user.role === Role.web_goddess;
    this.allow_testing    = this.dev_mode;
    this.use_color_brewer = false;
    this.show_ms          = SHOW_MS || this.agrosat_user;   // mostramos los ms en el árbol?
    this.show_ms_book     = SHOW_MS;                        // mostramos los ms en el libro?
    this.tree_opened      = false;
    this.item_collect     = null;

    this.state = {
      user                   : props.user,
      show_tree              : true,
      four_maps              : false,
      symmetric_four_maps    : true,
      review_thematic        : false,
      fix_zoom               : false,
      filelist               : get_filelist(_.cloneDeep(props.user.true_exists)),    // no usar app.get_filelist(), porque this todavía es null
      show_menu_user         : false,
      show_dialog_user_create: false,
      show_dialog_user_edit  : false,
      show_dialog_thematic   : false,
      show_dialog_tools      : false,
      window_drag            : true,
      png_opacity            : 1,
      simplify_keep          : 1,
      num_decimals           : 2,
      ms_icon_pair           : ms_icons[1],
      edit_users             : [],
      num_colors_escala      : 9,
      name_escala            : 'RdYlGn',
      inv_escala             : false,
      result_measure         : NO_MEASURE,
      showing_mav            : false,
      closing_four_maps      : false,
      obs                    : null,
      sen                    : null,
      show_escalas_below     : false,
      alpha                  : null,
      include_mav_book       : false,
      include_mt_book        : false,
      show_config_book       : false,
      mapnik_method          : 'near',
      show_help              : false,
      tree_item_menu         : null,
      report_entries         : {entries: [], path: ''},
      disable_sidebar        : false,
      wait                   : false,
      open_last              : true,
      change_culti_on_close  : true,
      building_doc           : false,
      ui_clima_cooprinsem    : false,
      bios                   : [],
      collect_folder         : null,
      collect_point_opened   : null,
      show_jpg_url           : '',
      show_jpg_w             : -1,
      show_jpg_h             : -1,
      show_jpg_title         : '',
      show_appbar            : true,
      cond_show_collect_point: true,
      cond_show_jpg          : true,
      show_central_fert      : false,
      show_collect_mkdir     : false,
      collect_mkdir_path     : '',
      show_popup             : false,
      show_aviso             : false,
      custom_warning         : null,
      node_path              : null,
    };

    window.app = this;
    
    this.close_menus       = this.close_menus.bind(this);
    this.close_dialog_user = this.close_dialog_user.bind(this);
    this.toggle_four_maps  = this.toggle_four_maps.bind(this);
    this.toggle_fix_zoom   = this.toggle_fix_zoom.bind(this);
    this.map_clicked       = this.map_clicked.bind(this);
    this.dev_mode_testing  = this.dev_mode_testing.bind(this);
    this.start_book        = this.start_book.bind(this);
    this.config_book       = this.config_book.bind(this);
    this.create_user       = this.create_user.bind(this);
    this.save_my_account   = this.save_my_account.bind(this);
    this.is_black          = this.is_black.bind(this);
    this.close_alpha       = this.close_alpha.bind(this);
    
    window.onkeydown = (ev) => {
      const isEscape = 'key' in ev ? ev.key === 'Escape' || ev.key === 'Esc' : ev.keyCode === 27;

      if (isEscape) {
        this.close_menus();

        if (this.state.show_dialog_user_edit || this.state.show_dialog_user_create) {
          this.close_dialog_user();
        }

        if (this.state.show_dialog_thematic && this.dialog_thematic != null) {
          this.dialog_thematic.close();
        }

        if (this.state.obs != null && this.dialog_nota != null) {
          this.dialog_nota.close();
        }

        if (this.state.sen != null && this.dialog_sensor != null) {
          this.dialog_sensor.close();
        }
      }
    };
  }



  get_filelist(dirs: Array<string>): Array<T_Item> {
    return get_filelist(dirs.filter(fnot(this.is_black)));
  }



  toggle_fix_zoom = (): void => {
    this.setState({fix_zoom: ! this.state.fix_zoom});
  }



  toggle_four_maps = (symmetric: boolean, next?: T_Next): void => {
    const end = () => {
      this.setState({four_maps: ! this.state.four_maps, symmetric_four_maps: symmetric}, () => {
        if (next != null && _.isFunction(next)) {
          next(true);
        }
      });
    };

    if (this.state.four_maps) {
      this.map_ui.setState({escala_for: null}, () => {     // NOTE: (may 3 2018) primero cerrar las escalas.
        this.setState({closing_four_maps: true}, () => {
          end();
        });
      });
    }
    else {
      this.map_ui.setState({restore_shp: '', restore_img: ''}, end);
    }
  }



  componentWillUnmount() {
    window.app = null;
  }



  close_dialog_user = (): void => {
    this.setState({show_dialog_user_edit: false, show_dialog_user_create: false}, () => {
      if (this.agrosat_user && (! this.dev_mode)) {
        if (this.toolbar != null) {
          this.toolbar.center_culti(false, true);
        }
      }
    });
  }



  user_saved_msg(): React.Node {
    return (
      <center>
        <Icon name='check-circle' size='lg' />
        <br />
        Cambios guardados
      </center>
    );
  }



  fx_dialog_user_closed(next: T_Next): void {
    const jdialog = $('.userpop');

    if (! jdialog.length) {
      return next(false);
    }

    const width  = jdialog.width() + 2,
          jdHead = $('.user_role_div'),
          jdForm = $('.user_forms'),
          height = jdHead.length > 0 ? 49 + jdForm.height() + 2 : jdForm.height() + 2,
          pos    = jdialog.position(),
          cx     = pos.left + 1,
          cy     = pos.top  + 1;

    this.setState({alpha: {cx, cy, width, height, msg: this.user_saved_msg(), cod: 'DLG_USER_CLOSED'}}, () => next(true));
  }



  close_dialog_user_deluxe(): void {
    this.fx_dialog_user_closed(() => {
      _.delay(() => {
        if (! this.state.alpha) {   // puede que el usuario haya cerrado el alpha dándole click.
          return;
        }

        this.setState({alpha: null}, () => {
          this.close_dialog_user();
        });
      }, 3000);
    });
  }



  get_conversions(): void {
    if (this.convs.length === 0) {
      const url = `${this.remote}/list-name-conversions/?session_id=${this.session()}`;

      fetch(url).then(resp => resp.json()).then((convs: Array<T_Conv>) => {
        this.convs = convs;

        this.convs.push({id: 99999, name: "OBS", ismf: false, conversion: "Observaciones"});

        this.mf_convs     = this.convs.filter(conv =>   conv.ismf);
        this.normal_convs = this.convs.filter(conv => ! conv.ismf);
      });
    }
  }



  componentDidMount() {
    this.get_conversions();

    const uname     = this.state.user.user_name,
          new_state = {};

    localforage.getItem(`${uname}.window_drag`).then((window_drag: ?boolean) => {
      localforage.getItem(`${uname}.png_opacity`).then((png_opacity: ?string) => {
        localforage.getItem(`${uname}.simplify_keep`).then((simplify_keep: ?string) => {
          localforage.getItem(`${uname}.ms_icon_pair`).then((ms_icon_pair: ?T_IconPair) => {
            localforage.getItem(`${uname}.num_decimals`).then((num_decimals: ?number) => {
              localforage.getItem(`${uname}.num_colors_escala`).then((num_colors_escala: ?number) => {
                localforage.getItem(`${uname}.name_escala`).then((name_escala: ?string) => {
                  localforage.getItem(`${uname}.inv_escala`).then((inv_escala: ?boolean) => {
                    localforage.getItem(`${uname}.open_last`).then((open_last: ?boolean) => {
                      localforage.getItem(`${uname}.change_culti_on_close`).then((change_culti_on_close: ?boolean) => {
                        if (isNumber(png_opacity)) {
                          new_state.png_opacity = parseFloat(png_opacity);
                        }

                        if (isNumber(simplify_keep)) {
                          new_state.simplify_keep = parseFloat(simplify_keep);
                        }

                        /* eslint-disable no-unneeded-ternary */
                        if (_.isBoolean(window_drag)) {
                          new_state.window_drag = window_drag ? true : false;
                        }

                        if (_.isBoolean(open_last)) {
                          new_state.open_last = open_last ? true : false;
                        }

                        if (_.isBoolean(change_culti_on_close)) {
                          new_state.change_culti_on_close = change_culti_on_close ? true : false;
                        }
                        /* eslint-enable no-unneeded-ternary */

                        if (ms_icon_pair) {
                          new_state.ms_icon_pair = ms_icon_pair;

                          Shp.icon_pair = ms_icon_pair;
                        }

                        if (typeof num_decimals === 'number') {
                          new_state.num_decimals = num_decimals;
                        }
                        else if (typeof num_decimals === 'string' && isNumber(num_decimals)) {
                          new_state.num_decimals = parseInt(num_decimals, 10);
                        }

                        if (typeof num_colors_escala === 'number') {
                          new_state.num_colors_escala = num_colors_escala;
                        }
                        else if (typeof num_colors_escala === 'string' && isNumber(num_colors_escala)) {
                          new_state.num_colors_escala = parseInt(num_colors_escala, 10);
                        }

                        if (typeof name_escala === 'string') {
                          new_state.name_escala = name_escala;
                        }

                        if (_.isBoolean(inv_escala)) {
                          /* eslint-disable no-unneeded-ternary */
                          new_state.inv_escala = inv_escala ? true : false;
                          /* eslint-enable no-unneeded-ternary */
                        }

                        this.setState(new_state, () => {
                          this.ready('Prefs');

                          if (this.dev_mode) {
                            _.delay(this.dev_mode_testing, 2000);
                          }
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }



  test_mt(): void {
    if (this.sidebar != null) {
      const {sidebar} = this;

      sidebar.setState({bt_active: 'Herramientas'}, () => {
        sidebar.tools_ui(() => {
          if (this.dialog_tools != null) {
            const {dialog_tools} = this;

            dialog_tools.setState({expanded: 'POST_PROCESO'}, () => {
              dialog_tools.join_ui();
            });
          }
        });
      });
    }
  }



  dev_mode_testing = (): void => {
    if (this.allow_testing) {
      // this.test_mt();
    }
  }



  componentDidUpdate(prevProps: T_AppProps, prevState: T_AppState) {
    if (this.map_ui && this.map_ui.map && this.map_ui.map.map && ! this.tree_opened) {  // NOTE: this.ready DEBERÍA
      const last_shp = this.map_ui.map.last_shp_path();                                 // IMPEDIR QUE SE EJECUTE
                                                                                        //  ESTE IF.
      const shp_dirs = _.uniq(_.map(_.keys(this.map_ui.map.Shp_List), takeDir));        // FIXME: BORRA ESTE IF.
                                                                                        // ¿QUÉ COÑO HACE ESTE IF?
      if (this.tree != null) {
        const {tree} = this;

        tree.setState({filelist: _.cloneDeep(this.state.filelist)}, () => {
          mapSeries(shp_dirs, (dir, callback) => {
            tree.open_path(dir, (item_dir) => {
              if (item_dir != null) {
                this.tree_opened = true;

                item_dir.refresh_all_sons(() => {
                  const item_shp = this.get_item_shp(last_shp);

                  if (item_shp != null) {
                    item_shp.scroll();
                  }

                  if (item_shp != null) {
                    item_shp.hilight();
                  }

                  callback(null, true);
                });
              }
              else {
                callback(null, true);
              }
            });
          }, (err, rs) => {});
        });
      }
    }

    if ((this.state.num_colors_escala !== prevState.num_colors_escala ||
        this.state.name_escala        !== prevState.name_escala ||
        this.state.inv_escala         !== prevState.inv_escala) && this.map_ui.map != null) {
      const png_path = this.map_ui.map.last_img_path();

      if (png_path) {
        this.map_ui.map.Img_List[png_path].reload(this);
      }
    }

    if (prevState.four_maps && (! this.state.four_maps) && this.state.show_dialog_thematic) {
      this.setState({show_dialog_thematic: false});
    }

    if (prevProps.width !== this.props.width || prevProps.height !== this.props.height) {
      if (this.four_maps != null) {
        this.four_maps.center_all(this.map_ui.map.last_shp_path(), noop);
      }
    }

    if (this.props.height < 540 && this.dev_mode && this.state.alpha == null) {
      this.setState({
        alpha: {
          cx    : (this.props.width  / 2) - 200,
          cy    : 50,
          width : 400,
          height: 40,
          msg   : <div><center>La pantalla es demasiado pequeña</center></div>,
          cod   : 'SCREEN_SIZE'
        }
      });
    }
    else if (this.props.height > 540 && this.state.alpha != null && this.state.alpha.cod === 'SCREEN_SIZE') {
      this.setState({alpha: null});
    }

    if (this.props.height !== prevProps.height && this.state.alpha != null && this.state.alpha.cod === 'DLG_USER_CLOSED') {
      this.fx_dialog_user_closed(noop);
    }

    if (prevState.show_tree && ! this.state.show_tree) {
      this.close_tree_menu();
    }
  }



  are_ready(components: Array<string>, who: string): boolean {
    return _.includes(components, who) && _.every(components, comp => this.is_ready[comp]);
  }



  ready(who: string): void {
    this.is_ready[who] = true;

    if (this.are_ready(['Tree', 'Map', 'Prefs'], who)) {
      if (this.state.open_last) {
        this.open_last(() => {
          this.tree_opened = true;

          const shp_path = this.map_ui.map.last_shp_path();

          if (this.tree != null) {
            const item_shp = this.get_item_shp(shp_path);

            if (item_shp != null) {
              item_shp.scroll();
            }
          }
        });
      }
      else {
        this.show_stgo();

        this.tree_opened = true;
      }
    }

    if ((! this.state.four_maps) && this.are_ready(['Map'], who) && this.medidas != null) {
      this.medidas.setup_draw();
    }

    if (this.are_ready(['Map0', 'Map1', 'Map2', 'Map3'], who) && this.four_maps != null && this.state.four_maps) {
      this.four_maps.setup(() => {
        if ((! this.state.symmetric_four_maps) && (! this.state.show_dialog_thematic)) {
          if (this.state.review_thematic) {
            this.setState({review_thematic: false});
          }
          else {
            this.setState({show_dialog_thematic: true});
          }
        }
      });
    }
  }



  session(): string {
    return this.state.user ? this.state.user.session_id : '';
  }



  close_tree_menu(): void {
    if (this.state.tree_item_menu) {
      const item = this.get_item_any(this.state.tree_item_menu.node.Path);

      if (item != null) {
        item.setState({hilight_fm: false});
      }

      this.setState({tree_item_menu: null});
    }
  }



  close_menus = (): void => {
    if (this.state.show_menu_user) {
      this.setState({show_menu_user: false});
    }

    if (this.state.show_config_book) {
      this.setState({show_config_book: false});
    }

    this.close_tree_menu();

    if (this.toolbar != null) {
      this.toolbar.close_menus();
    }
  }



  map_clicked = (map_num: number): void => {
    this.close_menus();
  }



  center(): void {
    if (this.toolbar != null) {
      this.map_ui.map.center_and_zoom_path(this.toolbar.state.culti);
    }
  }



  refresh_items(next: T_Next = noop): void {
    const end = () => {
      this.map_ui.setState({escala_for: this.map_ui.map.last_img_path()}, () => next(true));
    };

    if (this.tree != null) {
      const {tree} = this,
            dirs = _.uniq(_.map(this.map_ui.map.things_loaded(), takeDir));

      mapSeries(dirs, (dir: string, callback) => {
        const item_dir = tree.get_sub_dir(dir);

        if (item_dir != null) {
          item_dir.refresh_all_sons(() => callback(null, true));
        }
        else {
          callback(null, true);
        }
      }, (err, rs) => {
        end();
      });
    }
    else {
      next(false);
    }
  }



  get_ms_of(dir: string): ?TreeItemShp {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        return item_dir.shps.find(shp => shp.props.node.Cod === T_MS);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  get_images_of(dir: string): Array<TreeItemPng> {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        return item_dir.pngs;
      }
      else {
        return [];
      }
    }
    else {
      return [];
    }
  }



  prev_img(dir: string, png_filename: string): ?TreeItemPng {  // NOTE: los mt no se consideran
    const pngs  = this.get_images_of(dir),
          index = _.findIndex(pngs, png => png.props.node.File === png_filename);

    if (index <= 0) {
      return null;
    }
    else {
      return pngs[index - 1];
    }
  }



  next_img(dir: string, png_filename: string): ?TreeItemPng {  // NOTE: los mt no se consideran
    const pngs  = this.get_images_of(dir),
          index = _.findIndex(pngs, png => png.props.node.File === png_filename);

    if (index >= pngs.length - 1) {
      return null;
    }
    else {
      return pngs[index + 1];
    }
  }



  get_opened_image_of(dir: string): ?TreeItemPng {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        return item_dir.pngs.find(png => png.state.Loaded);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  get_first_image_of(dir: string): ?TreeItemPng {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        return _.head(item_dir.pngs);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  get_item_any(path: string): ?(TreeItemDir | TreeItemShp | TreeItemPng | TreeItemObs) {
    const ext    = takeExtension(path),
          is_dir = ext === 'dir',
          is_shp = ext === 'shp',
          is_png = ext === 'png',
          is_obs = ext === 'obs';

    return (is_dir ?
      this.get_item_dir(path)
    :
      (is_shp ?
        this.get_item_shp(path)
      :
        (is_png ?
          this.get_item_png(path)
        :
          (is_obs ?
            this.get_item_obs(path)
          :
            null
          )
        )
      )
    );
  }


  get_item_dir(dir: string): ?TreeItemDir {
    if (this.tree != null) {
      return this.tree.get_sub_dir(dir);
    }
    else {
      return null;
    }
  }



  get_item_shp(path: string): ?TreeItemShp {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(takeDir(path));

      if (item_dir != null) {
        return item_dir.shps.find(shp => shp.props.node.Path === path);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  get_item_png(path: string): ?TreeItemPng {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(takeDir(path));

      if (item_dir != null) {
        return item_dir.pngs.find(png => png.props.node.Path === path);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  get_item_obs(path: string): ?TreeItemObs {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(takeDir(path));

      if (item_dir != null) {
        return item_dir.obss.find(obs => obs.props.node.Path === path);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  has_sensor(path: string): boolean {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(takeDir(path));

      if (item_dir != null) {
        return item_dir.sens.length > 0;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }



  get_item_sen(path: string): ?TreeItemSen {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(takeDir(path));

      if (item_dir != null) {
        return item_dir.sens.find(sen => sen.props.node.Path === path);
      }
      else {
        return null;
      }
    }
    else {
      return null;
    }
  }



  reload_dir(dir: string, next: T_Next): void {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        item_dir.open(next);
      }
      else {
        next(false);
      }
    }
    else {
      next(false);
    }
  }



  is_unpub(dir: string): boolean {
    const imgs = this.get_images_of(dir);

    if (imgs.length > 0) {
      return imgs[0].props.node.Unpub;
    }
    else {
      return false;
    }
  }



  is_black = (path: string): boolean => {
    return _.some(this.state.user.black_dirs, bdir => `${path}/` === bdir || path_is_inside(path, bdir));
  }



  mostrable(node: T_Node): boolean {
    if (node.Type === 'dir') {
      if (node.File === 'lost+found') {
        return false;
      }

      if (this.is_black(node.Path)) {
        return false;
      }

      if (node.File.toLowerCase().match(/^x_/)) {
        return this.agrosat_user;
      }

      const only_for = node.File.match(/^[uU]_(.+)_/);

      if (only_for) {
        return this.dev_mode || this.state.user.user_name === only_for[1];
      }

      return true;
    }

    return (
      node.Type === 'shp' ||
      (node.Type === 'png' && ! node.File.toLocaleLowerCase().match(/^escala/)) ||
      node.Type === 'obs' ||
      node.Type === 'sensor'  ||
      node.Type === 'collect' ||
      (node.Type === 'pdf' && _.startsWith(node.Path, '/MAPS/Cooprinsem_CSP/') && _.startsWith(node.File, 'Informe_'))
    );
  }



  allowed(path: string, cod: T_Kind): boolean {
    if (cod !== T_DIR) {
      return true;
    }

    return _.some(this.state.user.true_dirs, dir => path_is_inside_bi(dir, path));
  }



  toggle_publish(dir: string, next: T_Next): void {
    if (this.tree != null) {
      const item_dir = this.tree.get_sub_dir(dir);

      if (item_dir != null) {
        item_dir.toggle_publish(next);
      }
    }
  }



  kill_these(paths: Array<string>, next: T_Next, opt: ?T_CloseOpts): void {
    if (paths.length === 0)
      return next(false);

    const items_shp = paths.filter(path => takeExtension(path) === 'shp').map(path => this.get_item_shp(path)).filter(_.identity),
          items_png = paths.filter(path => takeExtension(path) === 'png').map(path => this.get_item_png(path)).filter(_.identity);

    mapSeries(items_png, (item_png, callback) => {
      item_png.close(() => {
        callback(null, true);
      });
    }, (err, rs) => {
      mapSeries(items_shp, (item_shp, callback) => {
        item_shp.close(() => {
          callback(null, true);
        }, opt);
      }, (err, rs) => {
        next(true);
      });
    });
  }



  on_root(): boolean {
    return this.state.filelist.length === 1 && this.state.filelist[0].Path === ROOT_DIR;
  }



  get_first_culti(dir: string, next: (path: string) => void): void {
    let url = `${this.remote}/first-culti/?session_id=${this.session()}`;

    if (dir !== '') {
      url = `${url}&dir=${dir}`;       // FIXME: NECESITO MANEJAR EL OTRO CASO?
    }

    fetch(url).then(response => response.json()).then((first_culti: T_FirstCultiResponse) => {
      next(first_culti.response);
    });
  }



  show_stgo(): void {
    this.map_ui.map.map.setCenter({lat: -33.399439, lng: -70.576181});
  }



  open_last(next: T_Next = noop): void {
    const go = () => {
      localforage.getItem(`${this.state.user.user_name}.last_culti`).then((culti: ?string) => {
        if (this.map_ui.map.is_loaded(culti || '')) {
          return next(false);
        }

        localforage.getItem(`${this.state.user.user_name}.last_png'`).then((png: ?string) => {
          if (this.tree != null) {
            const {tree} = this;

            const fin = (item_dir, use_culti) => {
              if (typeof png === 'string' && takeDir(png) === takeDir(use_culti) && item_dir != null) {
                const item_png = item_dir.pngs.find(png => png.props.node.Path === png);

                if (item_png != null) {
                  item_png.open(() => next(true));
                }
                else {
                  next(false);
                }
              }
              else {
                next(false);
              }
            };

            if (culti) {
              const the_culti = culti;

              tree.open_path(the_culti, (item_dir) => {
                fin(item_dir, the_culti);
              });
            }
            else {
              this.get_first_culti('', (first_culti) => {
                tree.open_path(first_culti, (item_dir) => {
                  fin(item_dir, first_culti);
                });
              });
            }
          }
        });
      });
    };

    localforage.getItem(`${this.state.user.user_name}.last_culti`).then((culti: ?string) => {
      if (typeof culti === 'string' && (! this.allowed(takeDir(culti), T_DIR))) {
        this.get_first_culti('', (first_culti: string) => {                                 // FIXME: ¿está bien ese dir ''?
          localforage.setItem(`${this.state.user.user_name}.last_culti`, first_culti).then(() => {
            localforage.setItem(`${this.state.user.user_name}.last_png`, '').then(() => {
              go();
            });
          });
        });
      }
      else {
        go();
      }
    });
  }



  esc_url_params(): string {
    const esc_family = `&esc_family=${this.state.name_escala}`,
          esc_colors = `&esc_colors=${this.state.num_colors_escala}`,
          esc_inv    = `&esc_inv=${hs_bool(this.state.inv_escala)}`;

    return `${esc_family}${esc_colors}${esc_inv}`;
  }



  post_json(obj: Object, path: string, next: T_NextErrOk): void {  // guarda un objeto JSON en un determinado path.
    $.ajax({
      type    : 'POST',
      url     : `${this.remote}/write-json-obj/?session_id=${this.session()}&path=${path}`,
      dataType: 'json',
      async   : true,
      data    : {obj: JSON.stringify(obj)},
      success : next
    });
  }



  user_can_search(): boolean {
    if (this.state.user.true_exists.length > 1) {
      return true;
    }

    const ps = this.state.user.true_exists[0].split('/').filter(_.identity);

    if (ps.length >= 5) {
      return ! is_date(_.last(ps));
    }
    else {
      return true;
    }
  }



  alpha_pos() {
    if (this.state.alpha) {
      return {
        top   : this.state.alpha.cy,
        left  : this.state.alpha.cx,
        width : this.state.alpha.width,
        height: this.state.alpha.height
      };
    }
    else {
      return {top: 1, left: 1, width: 1, height: 1};
    }
  }



  // copia varios archivos pertenecientes a una misma carpeta a un mismo destino.
  // esta función es más rápida que copy_files, porque todos los archivos residen en la misma carpeta.

  copy_files_from(path_from: string, files: Array<string>, tmp_dir: string, next: T_NextErrOk): void {
    const params = `path_from=${path_from}&path_to=${tmp_dir}&files=${files.join(',')}`,
          url = `${this.remote}/copy-many-files/?session_id=${this.session()}&${params}`;

    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }



  // copia varios archivos desde distintas carpetas a un mismo destino.

  copy_files(paths: Array<string>, tmp_dir: string, next: T_NextErrOk): void {
    if (paths.length === 0) {
      return next({ok: 'nada que hacer'});
    }

    const SAME_ORIGIN = _.uniq(paths.map(takeDir)).length === 1;

    if (SAME_ORIGIN) {
      return this.copy_files_from(takeDir(paths[0]), paths.map(takeFilename), tmp_dir, next);
    }
    else {
      mapSeries(paths, (path, callback) => {
        const dest = `${strip_end_slash(tmp_dir)}/${takeFilename(path)}`,
              url  = `${this.remote}/copy-one-file/?session_id=${this.session()}&path_from=${path}&path_to=${dest}`;

        fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
          if (response.error && typeof response.error === 'string') {
            callback(true, dest);
          }
          else {
            callback(null, dest);
          }
        });
      }, (err, dests) => {
        next(err ?
          {error: 'Hubo un error al copiar los archivos.'}
        :
          {ok: 'Los archivos fueron copiados exitosamente.'}
        );
      });
    }
  }



  mkdir(path: string, next: T_NextErrOk): void {
    const url = `${this.remote}/mkdir/?session_id=${this.session()}&path=${path}`;

    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }



  favorite_font(): string {
    return 'OpenSans';
  }



  favorite_font_title(): string {
    return 'OpenSans';
  }



  god_mode(): boolean {
    return this.state.user.role === Role.web_goddess;
  }



  build_pdf(culti: string, tmp_dir: string, pdf_path: string, has_logo: boolean, logo: string, service: string, date1: string, date2: string, next: T_NextErrOk): void {
    const url = `${this.remote}/build-pdf/?session_id=${this.session()}&tmp_dir=${tmp_dir}&pdf_file=${takeFilename(pdf_path)}&culti=${culti}&has_logo=${hs_bool(has_logo)}&logo=${logo}&service=${service}&remote=${this.remote}&date1=${date1}&date2=${date2}`;

    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }



  guess_service_name(culti_path: string, item_ms: ?TreeItemShp): string {
    const dirs = _.initial(_.drop(culti_path.split('/'), 5)),
          has  = (str: string): boolean => _.some(dirs, dir => dir.indexOf(str) !== -1);

    if (has('biosense'         )) { return 'biosense'          ; }
    if (has('climasense'       )) { return 'climasense'        ; }
    if (has('countcheck'       )) { return 'countcheck'        ; }
    if (has('cropsense'        )) { return 'cropsense'         ; }
    if (has('electrocheck'     )) { return 'electrocheck'      ; }
    if (has('fertisense'       )) { return 'fertisense'        ; }
    if (has('hydrosense'       )) { return 'hydrosense'        ; }
    if (has('nitrosense'       )) { return 'nitrosense'        ; }
    if (has('nutricheck_foliar')) { return 'nutricheck_foliar' ; }
    if (has('adn_foliar'       )) { return 'nutricheck_foliar' ; }  // sinónimo
    if (has('nutricheck_suelo' )) { return 'nutricheck_suelo'  ; }
    if (has('adn_suelo'        )) { return 'nutricheck_suelo'  ; }  // sinónimo
    if (has('adnet'            )) { return 'nutricheck_suelo'  ; }
    if (has('photosense'       )) { return 'photosense'        ; }
    if (has('nvdi'             )) { return 'ndvi'              ; }
    if (has('procheck'         )) { return 'procheck'          ; }
    if (has('qualitycheck'     )) { return 'qualitycheck'      ; }
    if (has('soilcheck'        )) { return 'soilcheck'         ; }
    if (has('thermosense'      )) { return 'thermosense'       ; }

    if (item_ms) {
      const file = item_ms.get_file();

      if (file.indexOf('ms_' ) === 0) { return 'nutricheck_suelo'  ; }
      if (file.indexOf('mfs_') === 0) { return 'nutricheck_foliar' ; }
    }

    return 'sin_servicio';
  }



  make_book_pdf(tmp_dir: string, date: T_Date, font_size: number, date1: string, date2: string, mt_labels: Array<string>, next: T_NextPath): void {
    if (this.toolbar != null) {
      const path     = this.toolbar.state.culti,
            dir      = fixslash(takeDir(path)),
            item_dir = this.get_item_dir(dir);

      if (item_dir != null) {
        const item_ms            = item_dir.get_ms(),
              ps                 = _.compact(dir.split('/')),
              service_name       = this.guess_service_name(path, item_ms),
              is_crop            = service_name === 'cropsense',
              is_clima           = service_name === 'climasense',
              is_adnet           = service_name === 'adnet',
              is_biosense        = service_name === 'biosense',
              is_prchk           = path.includes('procheck_pradera'),
              is_coopr           = _.startsWith(ps[1], 'Cooprinsem'),
              is_netafim         = _.startsWith(ps[1], 'riegosistemas_netafim'),
              is_semagro         = dir.startsWith('/MAPS/Semagro'),
              is_upl             = dir.includes('UPL'),
              mb_date            = is_semagro && ps.length > 5 ? ps[5] : '',
              prchk_date         = is_prchk ? ps[ps.length - 1] : '',
              str_date           = is_date(mb_date) ? `_${mb_date}` : '',
              logo_prefix        = is_netafim ? (is_adnet ? 'adnet_' : (is_biosense ? 'idnet_' : '')) : '',
              logo_programa      = `${logo_prefix}${ps[1]}.jpg`,
              path_logo_programa = `/app/data/libro_predios/logos/${logo_programa}`,
              path_portada       = '/app/data/libro_predios/img_neobook/portada.jpg',
              path_contraportada = '/app/data/libro_predios/img_neobook/contraportada.png',
              path_header        = `/app/data/libro_predios/img_neobook/headers/${is_crop && ! is_coopr ? 'raw_' : ''}${is_upl ? `upl_${service_name}` : (is_prchk ? 'cropsense' : service_name)}.png`,
              path_footer        = '/app/data/libro_predios/img_neobook/pie_pagina.png',
              predio             = mk_title(ps[3].replace(new RegExp('_', 'g'), ' ')),
              prefix_service     = is_coopr ? (is_crop ? 'Cropsense_' : (is_clima ? 'Climasense_' : '')) : '',
              pdf_path           = is_prchk ? `${dir}/Informe_${prefix_service}${S.replaceAll(predio, ' ', '_')}${str_date}_${prchk_date}.pdf` : `${dir}/Informe_${prefix_service}${S.replaceAll(predio, ' ', '_')}${str_date}.pdf`,
              base_imgs          = [path_portada, path_contraportada, path_header, path_footer];
              // console.log(is_upl);
              // console.log(path_header);

        // console.log(item_ms, service_name);
        // console.log(is_prchk, ps[ps.length - 1]);
        let has_prog_logo = true;

        if (mt_labels.length > 0) {
          base_imgs.push(PATH_ESCALA_MT);
        }

        this.copy_files([path_logo_programa], tmp_dir, (result_copy_logo: T_ErrOk) => {
          if (result_copy_logo.error && typeof result_copy_logo.error === 'string') {
            has_prog_logo = false;
          }

          // console.log('has_prog_logo', has_prog_logo);

          this.copy_files(base_imgs, tmp_dir, (result_copy: T_ErrOk) => {
            if (result_copy.error && typeof result_copy.error === 'string') {
              Alert.error(result_copy.error);
            }
            else {
              this.build_pdf(path, tmp_dir, pdf_path, has_prog_logo, logo_programa, service_name, date1, date2, (result_build: T_ErrOk) => {
                if (result_build.error && typeof result_build.error === 'string') {
                  Alert.error(result_build.error);

                  this.setState({building_doc: false, wait: false});
                }
                else {
                  next(pdf_path);       // AQUÍ TERMINA EL PROCESO DE CONSTRUCCIÓN DEL PDF.
                }
              });
            }
          });
        });
      }
      else {
        Alert.error('No puedo encontrar la carpeta.');
      }
    }
    else {
      Alert.error('No pude encontrar el cultivable.');
    }
  }



  copy_escalas_screenshoter(esc_paths: Array<string>, dest_dir: string, next: (copied_escs: Array<string>) => void): void {
    let map_num = 1;

    mapSeries(esc_paths, (esc_path, callback) => {
      const dest = `${strip_end_slash(dest_dir)}/esc_${map_num}.png`,
            url  = `${this.remote}/copy-one-file/?session_id=${this.session()}&path_from=${esc_path}&path_to=${dest}`;

      map_num += 1;

      fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
        if (response.error && typeof response.error === 'string') {
          callback(true, dest);
        }
        else {
          callback(null, dest);
        }
      });
    }, (err, dests) => {
      next(err ? [] : dests);
    });
  }



  mapnik_screenshots(idir: string, odir: string, culti: string, ms: string,
                    elems: T_Paths, mavs: T_Paths, mtdir: string, mts: T_Paths,
                    font_size: number, method: T_MapnikMethods, next: T_NextErrOk): void {
    // console.log('mapnik_screenshots idir ', idir );
    // console.log('mapnik_screenshots odir ', odir );
    // console.log('mapnik_screenshots elems', elems);
    // console.log('mapnik_screenshots mavs ', mavs );
    // console.log('mapnik_screenshots mts  ', mts  );
    
    const str_elems = elems.length > 0 ? elems.join(',') : 'NO',
          str_mavs  =  mavs.length > 0 ?  mavs.join(',') : 'NO',
          str_mts   =   mts.length > 0 ?   mts.join(',') : 'NO',
          params    = `idir=${idir}&odir=${odir}&culti=${culti}&ms=${ms}&elems=${str_elems}&mavs=${str_mavs}&mtdir=${mtdir}&mts=${str_mts}`,
          cfg       = `font_size=${font_size}&method=${method}`,
          url       = `${this.remote}/mapnik-screenshots/?session_id=${this.session()}&${params}&${cfg}`;

    fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
      next(response);
    });
  }



  get_fecha_servicio(dir: string, next: T_NextDate): void {
    const url = `${this.remote}/get-fecha-servicio/?session_id=${this.session()}&dir=${dir}`;

    fetch(url).then(resp => resp.json()).then((response: T_Date) => {
      next(response);
    });
  }



  get_mtdir_of(dir: string, next: T_NextPath): void {
    const mtdir1 = `${takeDir(dir)}/Mapas_tematicos`;

    does_path_exists(this, mtdir1, (exist1: boolean) => {
      if (exist1) {
        next(mtdir1);
      }
      else {
        const mtdir2 = `${takeDir(takeDir(dir))}/Mapas_tematicos`;

        does_path_exists(this, mtdir2, (exist2: boolean) => {
          next(exist2 ? mtdir2 : '');
        });
      }
    });
  }



  // NOTE: Toolbar(Botón informe) -> app.start_book -> app.make_book_pdf

  start_book = (font_size: number, method: T_MapnikMethods, date1: string, date2: string): void => {
    if (this.toolbar != null && this.tree != null) {
      const {tree}  = this,
            {culti} = this.toolbar.state,
            dir     = takeDir(culti);

      this.setState({building_doc: true, wait: true});

      this.map_ui.map.fix_resize();
      this.map_ui.map.set_ui(false);
      this.map_ui.map.set_interacion(false);
      this.map_ui.map.set_zoom_controls(false);

      const url1 = `${this.remote}/make-tmp-dir/?session_id=${this.session()}`;

      fetch(url1).then(resp => resp.json()).then((response_tmp: T_ErrOk) => {
        if (response_tmp.error && typeof response_tmp.error === 'string') {
          Alert.error(response_tmp.error);
        }
        else if (response_tmp.ok && typeof response_tmp.ok === 'string') {
          const tmp_dir = response_tmp.ok;

          this.get_mtdir_of(dir, (mtdir: string) => {
            // console.log('mtdir:', mtdir);

            tree.open_path(mtdir, () => {
              preload_escalas(this, dir, (escs) => {
                this.copy_escalas_screenshoter(escs.map(esc => get_path_escala(esc)), tmp_dir, (copied_escs: Array<string>) => {
                  const item_dir    = this.get_item_dir(dir),
                        item_mt_dir = this.get_item_dir(mtdir);

                  // console.log('item_mt_dir is null:', item_mt_dir == null);
                  //
                  // if (item_mt_dir != null) {
                  //   console.log('items en mt_dir:', item_mt_dir.get_mts());
                  // }

                  if (item_dir != null) {
                    const ms     = this.show_ms_book ? item_dir.get_ms() : null,
                          elems  = item_dir.pngs.filter(png => ! png.is_MT()).map(png => png.props.node.File),
                          mavs   = this.state.include_mav_book ? item_dir.get_mavs() : [],
                          mts    = this.state.include_mt_book  ? item_mt_dir != null ? item_mt_dir.get_mts() : [] : [],   // Array<TreeItemPng>
                          fculti = takeFilename(culti),
                          fms    = ms != null ? ms.get_file() : 'NO',
                          fmavs  = mavs.map(it => it.get_file()),
                          fmts   =  mts.map(it => it.get_file());

                    // console.log('mts:', mts);

                    this.mapnik_screenshots(dir, tmp_dir, fculti, fms, elems, fmavs, item_mt_dir != null ? mtdir : 'NO', fmts, font_size, method, (mapnik_response: T_ErrOk) => {
                      if (mapnik_response.error && typeof mapnik_response.error === 'string') {
                        Alert.error(mapnik_response.error);
                      }
                      else {
                        this.get_fecha_servicio(dir, (date: T_Date) => {
                          this.make_book_pdf(tmp_dir, date, font_size, date1, date2, mts.map(it => it.props.node.label), (pdf_path) => {
                            this.map_ui.setState({mav_detail: null});

                            this.download(`${this.remote}/get-pdf/?path=${pdf_path}&session_id=${this.session()}`, takeFilename(pdf_path));

                            this.setState({show_config_book: false, building_doc: false, wait: false});
                          });
                        });
                      }
                    });
                  }
                  else {
                    Alert.error('No se encontró la carpeta.');
                  }
                });
              });
            });
          });
        }
      });
    }
  }



  download(url: string, filename: string): void {
    // console.log('download', url, filename);

    let link = document.createElement("a");
    link.download = filename;
    link.href = url;

    const parent = document.getElementById('app_bar');

    if (parent != null) {
      parent.appendChild(link);
    }

    link.click();

    if (parent != null) {
      parent.removeChild(link);
    }

    link = null;
  }



  config_book = (): void => {
    if (! this.state.show_central_fert) {
      this.setState({show_config_book: true}, () => {
        if (this.toolbar != null) {
          this.toolbar.close_menus();
        }
      });
    }
  }



  close_mt_view(next: T_Next): void {
    if (this.four_maps != null && ! this.four_maps.props.symmetric) {
      this.toggle_four_maps(true, () => {
        _.delay(() => {
          if (this.four_maps != null) {
            this.toggle_four_maps(true, () => {
              _.delay(next, 400);
            });
          }
          else {
            _.delay(next, 400);
          }
        }, 400);
      });
    }
    else {
      next(false);    // fucker call next on every path!
    }
  }



  create_user = (_user: ?T_User): void => {
    if (_user != null) {
      const user = _user;

      remote_save(this, user, true, (result: T_ErrOk) => {
        if (result.error && typeof result.error === 'string') {
          Alert.error(result.error);
        }
        else {
          this.setState({show_dialog_user_create: false}, () => {
            localforage.setItem('testing_user', `${user.user_name}:${user.pass}`).then((res) => {
              window.open(`${window.location.href}?new_login`, '_blank');
            });;
          });
        }
      });
    }
    else if (this.dialog_user_make != null) {
      this.dialog_user_make.set_errors();
    }
  }



  save_my_account = (_user: ?T_User): void => {
    if (_user != null) {
      const user = _user;

      save_my_account(this, user, (result: T_ErrOk) => {
        if (result.error && typeof result.error === 'string') {
          Alert.error(result.error);
        }
        else {
          this.close_dialog_user_deluxe();

          localforage.setItem('last_user', `${user.user_name}:${user.pass}`).then((res) => {
            localforage.setItem('full_user', user).then((res) => {});
          });
        }
      });
    }
  }



  can_admin_users(): boolean {
    return this.agrosat_user || this.state.user.role === Role.coordinador;
  }



  // FIXME: esta función debe retornar false para los cultis/elementos, excepto si soy de agrosat.
  // esta función debe ser asíncrona, y debe chequear el autor del archivo MT/MAV/OBS
  // si yo no soy el autor, y quiero borrar el nodo, al menos debo preguntar si está seguro.
  // esta función no debe retornar un simple booleano, sino info acerca del autor del archivo,
  // si es un archivo generado por el usuario o uno generado por producción, si debo preguntar antes de borrar, etc.

  can_admin_file(node: T_Item): boolean {
    return _.includes(Role.known, this.state.user.role);
  }



  set_edit_users(): void {
    fetch_users_min(this, (resp: T_UsersMinErr) => {
      if (resp.error && typeof resp.error === 'string') {
        Alert.alert(resp.error);
      }
      else if (resp instanceof Array) {
        const am_coord = this.state.user.role === Role.coordinador,
              not_me   = user => this.state.user.user_name !== user.user_name,
              editable = user => user.role === Role.coordinador_externo || user.role === Role.asesor_externo || user.role === Role.agricultor || (user.role === Role.coordinador && this.agrosat_user) || this.god_mode();

        const my_son = (user) => {
          if (this.agrosat_user) {
            return true;
          }
          else if (am_coord) {
            if (user.true_dirs.length === 0) {
              return false;
            }

            // dicho en palabras: un usuario es mi hijo si todos sus directorios están dentro de alguno de mis directorios (si alguno de sus directorios están fuera de los mios, no es mi hijo).

            return _.every(user.true_dirs, oth_dir => _.some(this.state.user.true_dirs, my_dir => oth_dir === my_dir || path_is_inside(oth_dir, my_dir)));
          }

          return false;
        };

        this.setState({
          edit_users: _.orderBy(resp, ['user_name'], ['asc']).filter(f_and3(editable, not_me, my_son))
        }, () => {
          this.sidebar.hide_all(true);
        });
      }
    });
  }



  close_alpha = (): void => {
    if (this.state.alpha != null && this.state.alpha.cod === 'DLG_USER_CLOSED' && this.state.show_dialog_user_edit) {
      this.close_dialog_user();
    }

    this.setState({alpha: null});
  }



  log_user_action(action: string, path: string): void {
    const url  = `${this.remote}/log-user-action/?session_id=${this.session()}&action=${action}&path=${path}`;

    fetch(url).then(resp => resp.json()).then((success: boolean) => {
      if (! success) {
        console.error(`No se pudo notificar la acción ${action}`);
      }
    });
  }



  url = (action: string, params: string): string => {
    return `${this.remote}/${action}/?session_id=${this.session()}&${params}`;
  };



  make_link(url: string): void {
    let link  = document.createElement('a');

    link.href = url;

    if (document.body != null) {
      document.body.appendChild(link);
    }

    link.click();

    if (document.body != null) {
      document.body.removeChild(link);
    }

    link = null;
  }



  close_custom_warn = (): void => {
    this.setState({custom_warning: null});
  };

  render() {
    const {width, height} = this.props,
          height_sty = {height, maxHeight: height, width: '100%', fontFamily: this.favorite_font()},
          sty_div_tree = {
            display: this.state.show_tree ? 'block' : 'none',
            maxHeight: height,
            height: height + 40 - 365,
          },
          pixelUser = [8786, 9036, 9107],
          tag_hl    = ["ID", ""],
          tecnos    = ['Fertirriego', 'Aspersión', 'Canal de riego', 'Cobertera', 'Incorporado']
    ;
    
    return (
      
      
      <MuiThemeProvider muiTheme={theme(this.favorite_font())}>
        <div id='fullscreen' style={height_sty}>
          <div id='two_panels' style={height_sty}>
          {this.state.show_aviso && 
              <Aviso
                app={this}
                
              />
            }
            <SideBar
              uname={this.state.user.real_name}
              height={height}
              show_user={true}
              showing_dialog_user={this.state.show_dialog_user_edit || this.state.show_dialog_user_create}
              show_bt_crear={true}
              disable_tree_bt={false}
              disable_all={
                (this.state.alpha != null && this.state.alpha.cod === 'DLG_USER_CLOSED') ||
                this.state.disable_sidebar || this.state.show_central_fert
              }
              app={this}
            />

            <div className='treepop' style={sty_div_tree}>
              <Tree
                filelist={_.cloneDeep(this.state.filelist)}
                search_ui={true}
                height={height}
                pop_height={sty_div_tree.height}
                show_ms={this.show_ms}
                disabled={false}
                app={this}
              />
            </div>

            <AppBar
              show_tree={this.state.show_tree}
              four_maps={this.state.four_maps}
              fix_zoom={this.state.fix_zoom}
              hide_extras={this.state.sen != null}
              width={width}
              app={this}
              window_drag={this.state.window_drag}
              launcher={this.props.launcher}
              num_decimals={this.state.num_decimals}
              dev_mode={false}
              agrosat_user={this.agrosat_user}
              closing_four_maps={this.state.closing_four_maps}
              use_pixel_tool={USE_PIXEL_TOOL || this.agrosat_user || pixelUser.includes(this.props.user.id)}
              configuring_doc={this.state.show_config_book}
              cond={this.state.show_appbar}
            />

            <MapUI
              four_maps={this.state.four_maps}
              symmetric_four_maps={this.state.symmetric_four_maps}
              fix_zoom={this.state.fix_zoom}
              show_tree={this.state.show_tree}
              hide_extras={this.state.collect_folder != null}
              width={width}
              height={height}
              window_drag={this.state.window_drag}
              show_dialog_user={this.state.show_dialog_user_edit || this.state.show_dialog_user_create}
              show_dialog_tools={this.state.show_dialog_tools}
              num_decimals={this.state.num_decimals}
              dev_mode={this.dev_mode}
              use_color_brewer={this.use_color_brewer}
              full_height={true}
              closing_four_maps={this.state.closing_four_maps}
              show_escalas_below={this.state.show_escalas_below}
              map_border={false}
              app={this}
            />

            {this.state.show_dialog_user_create &&
              <DialogUser
                app={this}
                window_drag={this.state.window_drag}
                show_titles={! this.dev_mode}
                width={width}
                height={height}
                create_mode={true}
                edit_dirs={true}
                only_edit_dirs={false}
                the_user={EMPTY_USER}
                proceed={this.create_user}
                cancel={this.close_dialog_user}
                top={50}
                left={(width / 2) - 200}
              />
            }

            {this.state.show_dialog_user_edit &&
              <DialogUser
                app={this}
                window_drag={this.state.window_drag}
                show_titles={! this.dev_mode}
                width={width}
                height={height}
                create_mode={false}
                edit_dirs={this.agrosat_user}
                only_edit_dirs={false}
                the_user={this.state.user}
                proceed={this.save_my_account}
                cancel={this.close_dialog_user}
              />
            }

            {this.state.show_dialog_thematic &&
              <DialogThematic
                app={this}
                culti={this.map_ui.map.last_shp_path()}
                window_drag={this.state.window_drag}
                show_escalas_below={this.state.show_escalas_below}
              />
            }

            {this.state.show_dialog_tools &&
              <DialogTools
                showing_thematic={this.state.show_dialog_thematic}
                showing_mav={this.state.showing_mav}
                showing_diff={this.state.bios.length > 1}
                show_tree={this.state.show_tree}
                four_maps={this.state.four_maps}
                fix_zoom={this.state.fix_zoom}
                result={this.state.result_measure}
                height={height}
                use_pixel_tool={USE_PIXEL_TOOL || this.agrosat_user || pixelUser.includes(this.props.user.id)}
                can_admin_users={this.can_admin_users()}
                num_decimals={this.state.num_decimals}
                open_last={this.state.open_last}
                change_culti_on_close={this.state.change_culti_on_close}
                app={this}
              />
            }

            {this.state.obs != null &&
              <DialogNota
                obs={this.state.obs}
                app={this}
              />
            }

            {this.state.sen != null &&
              <DialogSensor
                window_drag={this.state.window_drag}
                sen={this.state.sen}
                app={this}
                toolbar={this.toolbar}
                width={width}
                height={height}
                email={this.state.user.email}
              />
            }

            {this.state.alpha != null &&
              <div className='alpha_trans' style={this.alpha_pos()} onClick={this.close_alpha}>
                {this.state.alpha.msg}
              </div>
            }

            {(this.state.show_config_book && this.toolbar != null) &&
              <MenuBook
                app={this}
                dir={takeDir(this.toolbar.state.culti)}
                include_mav_book={this.state.include_mav_book}
                include_mt_book={this.state.include_mt_book}
                mapnik_method={this.state.mapnik_method}
                show_tree={this.state.show_tree}
                building_doc={this.state.building_doc}
              />
            }

            {this.state.show_help &&
              <Help can_admin_users={this.can_admin_users()} />
            }

            {this.state.tree_item_menu &&
              <TreeItemMenu {...this.state.tree_item_menu} app={this} />
            }

            {(this.state.report_entries.entries.length > 0) &&
              <DialogReport
                entries={this.state.report_entries.entries}
                path={this.state.report_entries.path}
                app={this}
                num_decimals={this.state.num_decimals}
              />
            }

            {(this.state.edit_users.length > 0) &&
              <SelectUser
                users={this.state.edit_users}
                width={width}
                height={height}
                app={this}
              />
            }

            {this.state.wait &&
              <div className='app_wait'>
                <Wait />
              </div>
            }

            {(this.state.bios.length > 1) &&
              <Diff
                paths={_.map(this.state.bios, 'png')}
                cultis={_.map(this.state.bios, 'culti')}
                app={this}
              />
            }

            {this.state.ui_clima_cooprinsem &&
              <ClimaCooprinsem
                app={this}
              />
            }

            {this.state.collect_folder &&
              <CollectPoints
                app={this}
                collect={this.state.collect_folder}
                show_tree={this.state.show_tree}
              />
            }

            {(this.state.collect_folder && this.state.collect_point_opened) &&
              <ShowCollectPoint
                app={this}
                point={this.state.collect_point_opened}
                cond={this.state.cond_show_collect_point}
              />
            }

            {(this.state.show_jpg_url && this.state.show_jpg_url.indexOf(this.remote) === 0) &&
              <XDialog
                name='app_show_jpg'
                style={(this.state.show_jpg_w > 0 && this.state.show_jpg_h > 0 ?
                  {top : (height - this.state.show_jpg_h) / 2, left: (width  - this.state.show_jpg_w) / 2} : {})}
                state_ctl='show_jpg_url'
                title={this.state.show_jpg_title}
                father={this}
                drag={false}
                frame_drag={true}
                toggleable={true}
                cond={this.state.cond_show_jpg}
                children={
                  <img
                    src={this.state.show_jpg_url}
                    alt=''
                    style={{maxWidth: '98vw', maxHeight: '90vh', width: 'auto', height: 'auto'}}
                    ref={this.handle_img_size}
                  />
                }
                font={this.favorite_font()}
              />
            }

            {this.state.show_central_fert &&
              <CentralFert
                app={this}
                tag_hl={tag_hl}
                tecnos={tecnos}
              />
            }

            {this.state.show_collect_mkdir &&
              <CollectMkdir
                app={this}
                path={this.state.collect_mkdir_path}
                close={() => this.setState({show_collect_mkdir: false})}
              />
            }

            {this.state.custom_warning != null &&
              <Dialog title='' actions={this.bts_warn()} modal={true} open={this.state.custom_warning != null} onRequestClose={this.close_custom_warn} contentStyle={{width: 400}}>
                {this.state.custom_warning}
              </Dialog>
            }

            {this.state.show_popup &&
              <PopUp
                app={this}
              />
            }
            
            
          </div>
        </div>
      </MuiThemeProvider>
    );
  }



  bts_warn() {
    return [
      <FlatButton
        label='Aceptar'
        primary={true}
        keyboardFocused={true}
        onClick={this.close_custom_warn}
      />
    ];
  }



  handle_img_size = (img: ?HTMLImageElement): void => {
    if (img) {
      this.setState({show_jpg_w: img.offsetWidth, show_jpg_h: img.offsetHeight});
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.jsx